export const Auth = {
  SignIn: '/signin',
  SignInResponse: '/login/callback',
  SignOut: '/signout',
}

export const home = '/'

export const Explore = {
  Home: '/explore',
  Detail: '/explore/:id',
  Drilldown: '/explore/:id/:subAsset',
}
